var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.28571429 0c.55228475 0 1.00000001.44771525 1.00000001 1L10.285 7.714 17 7.71428571c.5522847 0 1 .44771525 1 1v.57142858c0 .55228475-.4477153 1.00000001-1 1.00000001L10.285 10.285 10.2857143 17c0 .5522847-.44771526 1-1.00000001 1h-.57142858c-.55228475 0-1-.4477153-1-1L7.714 10.285 1 10.2857143c-.55228475 0-1-.44771526-1-1.00000001v-.57142858c0-.55228475.44771525-1 1-1L7.714 7.714 7.71428571 1c0-.55228475.44771525-1 1-1h.57142858z",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.2052f3c1a287a1ec6e438ca4bc494b41.svg";
export { ForwardRef as ReactComponent };